export const SignalizationSystemKeys = {
  sleeping: 'sleeping',
  isolationStatusNormal: 'isolationStatusNormal',
  cabStatusA: 'cabStatusA',
  cabStatusB: 'cabStatusB',
  direction: 'direction',
  tractionStatusForEtcs: 'tractionStatusForEtcs',
  magneticValvesIsolation: 'magneticValvesIsolation',
  emergencyBrakeFeedback1: 'emergencyBrakeFeedback1',
  emergencyBrakeFeedback2: 'emergencyBrakeFeedback2',
  brakeMode: 'brakeMode',
  atsPower: 'atsPower',
  atsActivationFeedback: 'atsActivationFeedback',
  atsActive: 'atsActive',
  trainTractionReady: 'trainTractionReady',
  emergencyBrake1: 'emergencyBrake1',
  emergencyBrake2: 'emergencyBrake2',
  tractionCutOff1: 'tractionCutOff1',
  tractionCutOff2: 'tractionCutOff2',
  atsIsolation: 'atsIsolation',
  atsActivation1: 'atsActivation1',
  atsActivation2: 'atsActivation2',
  isolation: 'isolation',
  dmiStatus: 'dmiStatus',
  rtm: 'rtm',
  jru: 'jru',
  psu: 'psu',
  evc: 'evc',
  nvc: 'nvc',
  btm: 'btm',
  tacho1Broken: 'tacho1Broken',
  tacho2Broken: 'tacho2Broken',
  doppler1Broken: 'doppler1Broken',
  doppler2Broken: 'doppler2Broken',
  dmiError: 'dmiError',
  dmiTemperatureError: 'dmiTemperatureError',
  dmiFanError: 'dmiFanError'
} as const;
